const MAX_CUE_CHARS = 85;
const MAX_CUE_WORDS = 16;

const EMOJI_RE =
  /[\u{1F1E6}-\u{1F1FF}\u{1F300}-\u{1FAFF}\u{2600}-\u{27BF}]|\u{FE0F}/gu;

const TOOLISH_LINE_RE =
  /^\s*(tool|function|debug|trace|input|output|result|args|arguments|json|observation|system)\b\s*[:=-]/i;

const FILLER_OPENING_RE =
  /^(sure|absolutely|definitely|of course|certainly|yes|yeah|yep|ok(?:ay)?|got it|right|no problem)[\s,!.:-]+/i;

function stripMarkdownAndNoise(text: string): string {
  const withoutCode = text
    .replace(/```[\s\S]*?```/g, " ")
    .replace(/`[^`]*`/g, " ");

  const withoutLinks = withoutCode
    .replace(/!\[([^\]]*)\]\([^)]+\)/g, "$1")
    .replace(/\[([^\]]+)\]\([^)]+\)/g, "$1")
    .replace(/https?:\/\/\S+/gi, " ");

  return withoutLinks
    .split(/\r?\n/)
    .map((line) =>
      line
        .replace(/^\s{0,3}(#{1,6}|[-*+]\s+|\d+[.)]\s+|>\s*)/g, "")
        .replace(/\|/g, " ")
        .trim(),
    )
    .filter((line) => line && !TOOLISH_LINE_RE.test(line))
    .join(" ")
    .replace(/[*_~#>]/g, "")
    .replace(EMOJI_RE, " ")
    .replace(/\s+/g, " ")
    .trim();
}

function stripFillerOpening(text: string): string {
  let next = text.trim();
  for (let i = 0; i < 3; i += 1) {
    const stripped = next.replace(FILLER_OPENING_RE, "").trim();
    if (stripped === next) break;
    next = stripped;
  }
  return next;
}

function pickFirstMeaningfulSentence(text: string): string {
  const sentences = text.match(/[^.!?]+[.!?]?/g) ?? [text];
  return (
    sentences
      .map((sentence) => sentence.trim())
      .find((sentence) => /[a-z]{3,}/i.test(sentence)) ?? ""
  );
}

function capCue(text: string): string {
  const words = text.split(/\s+/).filter(Boolean).slice(0, MAX_CUE_WORDS);
  if (words.length === 0) return "";

  let cue = words.join(" ");
  while (cue.length > MAX_CUE_CHARS && words.length > 1) {
    words.pop();
    cue = words.join(" ");
  }

  if (cue.length > MAX_CUE_CHARS) {
    cue = cue.slice(0, MAX_CUE_CHARS).replace(/\s+\S*$/, "");
  }

  return cue.replace(/[,:;.-]+$/g, "").trim();
}

export function buildMarcusVoiceCue(text: string): string | null {
  const cleaned = stripFillerOpening(stripMarkdownAndNoise(text));
  if (!/[a-z]{3,}/i.test(cleaned)) return null;

  const sentence = stripFillerOpening(pickFirstMeaningfulSentence(cleaned));
  const cue = capCue(sentence);
  return cue && /[a-z]{3,}/i.test(cue) ? cue : null;
}
